import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Grid2, useMediaQuery } from '@mui/material';
import { useTheme } from "@mui/material/styles";

const LanguageSwitcher = ({ switched, setSwitched, setChatmess, setRecentList }) => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down("lg"));

  const handleToggle = (lang) => {
    const newLanguage = lang;
    i18n.changeLanguage(newLanguage);
    localStorage.setItem("lang",i18n.language)
    setSwitched(!switched)
    setChatmess([])
    setRecentList([])
  };

  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      height: "47px",
      mt: { xs: 0, md: 3 },
      mr:{xs:0,sm:2,md:2,lg:0}
    }}>
      <Box sx={{
        background: 'linear-gradient(to right, rgb(53, 66, 255) 0%,#B87DFF, rgb(85, 247, 255) 100%)',
        display: 'flex',
        borderRadius: "20px",
        p: 0.5,
        mb: { xs: 0, md: 1 },
        mt: { xs: 2, md: 0 }
      }}>
        <Button onClick={() => handleToggle("it")} sx={{
          background: i18n.language === 'it' ? 'white' : "#FFFFFF80 0% 0% no-repeat padding-box",
          borderRadius: "20px",
          color: "#B5B5B5",
          mr: 0.5,
          minWidth: "50px",
          fontWeight:700
        }}>ITA</Button>
        <Button onClick={() => handleToggle("en")} sx={{
          background: i18n.language === 'en' ? 'white' : "#FFFFFF80 0% 0% no-repeat padding-box",
          borderRadius: "20px",
          color: "#B5B5B5",
          minWidth: "50px",
          fontWeight:700
        }}>ENG</Button>
      </Box>
    </Box>
  );
};

export default LanguageSwitcher;
